import { Amplify, ResourcesConfig } from 'aws-amplify';
import { AppConfig } from '@/types/config.types';
import { debug } from '@/config/constants';

export function configureAmplify(config: AppConfig): void {
  const amplifyConfig: ResourcesConfig = {
    Auth: {
      Cognito: {
        userPoolId: config.COGNITO_USER_POOL_ID,
        userPoolClientId: config.COGNITO_CLIENT_ID,
        identityPoolId: config.COGNITO_IDENTITY_POOL_ID,
        allowGuestAccess: true, // Enable anonymous/unauthenticated access
      },
    },
  };

  Amplify.configure(amplifyConfig);
  debug.log('✓ Amplify configured');
}
